import React, {useState} from "react";
import ListOfVideosLists from "./ts/ListOfVideosLists";
import VideosDB from "../../client-data/ts/VideosDB";
import {thisIsMobile} from "../../client-data/GlobalConstants";
import VideosDisplayerComponent from "./VideosDisplayerComponent";
import VideoFullScreenModal from "./VideoFullScreenModal";
import AnnotationModal from "../annotations/AnnotationModal";
import VideosDBToAnnotationDBConverter from "../../util/VideosDBToAnnotationDBConverter";


export default function VideosListFactoryComponent(props) {

    // console.log("VideosListFactoryComponent is called!");

    // const ANNOTATION_MODAL_SIZE = thisIsMobile ? "sm" : "lg";
    const ANNOTATION_MODAL_SIZE = thisIsMobile ? "sm" : "md";

    const [showFlag, setShowFlag] = useState(true);
    const [showVideoFullScreenModal, setShowVideoFullScreenModal] = useState(false);
    const [showAnnotationModal, setAnnotationModal] = useState(false);
    const [currentVideoData, setCurrentVideoData] = useState(null);
    const [constructorHasRun, setConstructorHasRun] = useState(false);
    const [videosData, setVideosData] = useState(null);
    const [annotationData, setAnnotationData] = useState(null);

    function constructor() {
        if (constructorHasRun) {
            return;
        }
        // console.log("[VideosListFactoryComponent]: constructor code is running!");
        setConstructorHasRun(true);
        let videosMeshBtnObj = null;
        const videosListWithMeshButtonIDs = new ListOfVideosLists(VideosDB);
        if (videosListWithMeshButtonIDs) {
            videosMeshBtnObj = videosListWithMeshButtonIDs.getVideosListByMeshBtnId(props.meshBtnId);
            if (videosMeshBtnObj) {
                // console.log("[VideosListFactoryComponent]", videosMeshBtnObj.videosList);
                setVideosData(videosMeshBtnObj.videosList);

            }
        }
    }

    const hideVideoDisplayModal = () => {
        setShowFlag(false);
        props.hideVideoDisplayModal();
    }

    const onClickToPlayVideo = (videoDataObj, isFullScreenRequested) => {
        /* If the app is running on a mobile phone, or if we click the full-screen
        button then show the video as a videoFullScreenComponent */
        console.log("[VideosListFactoryComponent]: ", VideosDBToAnnotationDBConverter.createAnnotationDBFromVideoDBRecord(videoDataObj));
        if (thisIsMobile || isFullScreenRequested) {
            // console.log("[VideosListFactoryComponent] mobile or full-screen is requested");
            setShowFlag(false);
            setShowVideoFullScreenModal(false);
            setAnnotationModal(true);
            setCurrentVideoData(videoDataObj);
            setAnnotationData(VideosDBToAnnotationDBConverter.createAnnotationDBFromVideoDBRecord(videoDataObj));

        } else {
            setShowFlag(false);
            setShowVideoFullScreenModal(false);
            setAnnotationModal(false);
            setCurrentVideoData(null);
            setAnnotationData(null);
        }
        props.onClickPlayVideo(videoDataObj, props.meshBtnId, isFullScreenRequested);
    }


    const onHideVideoFullScreenModal = () => {
        // console.log("[VideosListFactoryComponent is closing!")
        setShowVideoFullScreenModal(false);
        props.hideVideoFullScreen();
    }

    const onHideAnnotationModal = () => {
        setAnnotationModal(false);
        props.hideVideoFullScreen();
    }

    const videoFullScreenComponent = <VideoFullScreenModal show={showVideoFullScreenModal}
                                                           onHideModal={onHideVideoFullScreenModal}
                                                           videoData={currentVideoData}
                                                           modelType="lg"
    />;

    const annotationModal = <AnnotationModal showAnnotationModal={showAnnotationModal}
                                             hideAnnotationModal={onHideAnnotationModal}
                                             annotationModalSize={ANNOTATION_MODAL_SIZE}
                                             annotationData={annotationData}

    />;

    constructor();

    return (
        <div>
            {videoFullScreenComponent}
            {annotationModal}

            <VideosDisplayerComponent show={showFlag}
                                      close={hideVideoDisplayModal}
                                      videosData={videosData}
                                      modelType="md"
                                      onClickToPlayVideo={onClickToPlayVideo}
            />

            {/*<AnnotationModal showAnnotationModal={showFlag}*/}
            {/*                 hideAnnotationModal={onHideAnnotationModal}*/}
            {/*                 annotationModalSize={ANNOTATION_MODAL_SIZE}*/}
            {/*                 annotationData={annotationData}*/}

            {/*/>;*/}

        </div>
    )
}